<template>
    <div class="exam-perinfo-container">
      <el-card class="exam-info-card">
        <!-- 考生信息部分 -->
        <div class="student-info">
          <el-row>
            <el-col :span="16">
              <div class="info-title">考生信息</div>
              <div class="info-item"><strong>考生姓名：</strong>{{ userInfo.name }}</div>
              <div class="info-item"><strong>证件号码：</strong>{{ userInfo.idCard }}</div>
            </el-col>
          </el-row>
        </div>

        <el-divider></el-divider>

        <!-- 考试信息部分 -->
        <div class="exam-info">
          <div class="info-title">考试信息</div>
          <div class="info-item"><strong>准考证号：</strong>{{ userInfo.uname }}</div>
          <div class="info-item"><strong>考试模块：</strong>{{ exam.examSubject }}</div>
          <div class="info-item"><strong>考试时间：</strong>{{ formattedExamTime }}</div>
          <!-- <div class="info-item"><strong>考试考场：</strong>{{ exam.examLocation }}</div>
          <div class="info-item"><strong>座位号：</strong>007 号</div> -->
        </div>

        <!-- 进入考试按钮 -->
        <div class="button-container">
          <el-button type="primary" size="large" round class="enter-exam-button" @click="handleEnterExam">进入考试</el-button>
        </div>
      </el-card>
    </div>
</template>
  
<script>
import { ElCard, ElRow, ElCol, ElDivider, ElButton } from 'element-plus';
import { format } from 'date-fns';
import { mapGetters } from 'vuex';

export default {
    name: 'ExamineeinfoCard', // 修改组件名称
    components: {
        ElCard,
        ElRow,
        ElCol,
        ElDivider,
        ElButton,
    },
    data() {
      return {
        userInfo: JSON.parse(localStorage.getItem('userInfo')) || {}
      };
    },
    computed: {
      ...mapGetters(['getJoinedExam']),
      exam() {
        return this.getJoinedExam;
      },
      formattedExamTime() {
        if (this.exam.examStartTime && this.exam.examEndTime) {
          const startTime = format(new Date(this.exam.examStartTime), 'yyyy-MM-dd HH:mm');
          const endTime = format(new Date(this.exam.examEndTime), 'yyyy-MM-dd HH:mm');
          return `${startTime} ~ ${endTime}`;
        }
        return '';
      }
    },
    methods: {
      handleEnterExam() {
        this.$emit('enter-exam');
      }
    }
};
</script>
  
<style scoped>
.exam-perinfo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  height: 100vh;
}

.exam-info-card {
  max-width: 520px;
  width: 100%;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.student-info {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}

.student-photo {
  width: 100px;
  height: 110px;
  border-radius: 5px;
  object-fit: cover;
  border: 1px solid #ddd;
}

.info-item {
  margin: 5px 0;
  font-size: 14px;
}

.info-title {
  font-size: 25px;
  font-family: 'Arial Black', 'SimHei', sans-serif;
  font-weight: 900;
  text-shadow: 0.1px 0.1px 0 #000;
}

.code {
  color: #409eff;
}

.button-container {
  text-align: center;
  margin-top: 20px;
}

.enter-exam-button {
  width: 100%;
}
</style>
